import { Component } from '@theme/component';

/** Swym's own header launcher, which it injects after load. */
const SWYM_LAUNCHER = '#swym-inject-header';

/**
 * A second wishlist launcher for the mobile menu drawer.
 *
 * Swym binds only the launcher it injects, so a theme-rendered
 * `.swym-wishlist` anchor is inert unless their Launch Point config includes
 * the navigation menu. Rather than reimplementing their behaviour and
 * hardcoding a destination that would drift from their app config, this
 * forwards the click to their anchor — which works even while our CSS hides it
 * on mobile. The glyph comes from their icon font for the same reason.
 *
 * If their Launch Point config is ever widened, this component can be removed
 * and the anchor will bind on its own.
 *
 * @extends {Component<{}>}
 */
class SwymWishlistTrigger extends Component {
  /**
   * @param {Event} event - The click event.
   */
  open = (event) => {
    const launcher = document.querySelector(SWYM_LAUNCHER);

    // No launcher means Swym never loaded, or its launch point moved off the
    // header. Leave the event alone and let the anchor's href do the work.
    if (!(launcher instanceof HTMLElement)) return;

    event.preventDefault();
    launcher.click();
  };
}

if (!customElements.get('swym-wishlist-trigger-component')) {
  customElements.define('swym-wishlist-trigger-component', SwymWishlistTrigger);
}
